import type { AxiosInstance } from 'axios';
import type {
  PlotElement,
  PlotElementListResponse,
  ListQueryParams,
  EntityId,
} from '@/types';

export const getPlotElements = async (
  api: AxiosInstance,
  plot_id: EntityId,
  section_id: EntityId,
  limit = 50,
  start_key: string | undefined = undefined,
  name: string | undefined = undefined,
): Promise<PlotElementListResponse> => {
  const resp = await api.get<PlotElementListResponse>(
    `/plot/${plot_id}/section/${section_id}/element`,
    {
      params: { limit, start_key, name } as ListQueryParams,
    },
  );
  return resp.data;
};

export const getPlotElement = async (
  api: AxiosInstance,
  plot_id: EntityId,
  section_id: EntityId,
  element_id: EntityId,
): Promise<PlotElement> => {
  const resp = await api.get<PlotElement>(
    `/plot/${plot_id}/section/${section_id}/element/${element_id}`,
  );
  return resp.data;
};

export const updatePlotElement = async (
  api: AxiosInstance,
  plot_id: EntityId,
  section_id: EntityId,
  element_id: EntityId,
  values: Partial<Omit<PlotElement, 'entity_id' | 'created_at' | 'updated_at'>>,
): Promise<PlotElement> => {
  const resp = await api.put<PlotElement>(
    `/plot/${plot_id}/section/${section_id}/element/${element_id}`,
    values,
  );
  return resp.data;
};

